import {Injectable} from "@angular/core";

import {ReportError} from "app/app.service";
import {ApiService} from "app/services/domain/api.service";
import * as Models from "app/services/proxy/model/models";
import {Lookup} from "framework/services/utils.service";
import {UsersService} from "app/services/domain/users.service";

@Injectable()
export class UserPreferenceService
{
    constructor(private m_api: ApiService,
                private readonly m_users: UsersService)
    {}

    @ReportError
    public async listPreferenceValues(path: string): Promise<Lookup<Date>>
    {
        const response = await this.m_api.userPreferenceApi.listValues(this.m_users.userId, Models.UserPreferenceListRequest.newInstance({path: path}));

        return response.names;
    }

    @ReportError
    public listPreferenceSubKeys(path: string): Promise<string[]>
    {
        return this.m_api.userPreferenceApi.listSubKeys(this.m_users.userId, Models.UserPreferenceListRequest.newInstance({path: path}));
    }

    @ReportError
    public async setPreference(path: string,
                               name: string,
                               value: string)
    {
        await this.m_api.userPreferenceApi.set(this.m_users.userId, Models.UserPreference.newInstance({
                                                                                                                     path : path,
                                                                                                                     name : name,
                                                                                                                     value: value
                                                                                                                 }));
    }

    public async getPreference(path: string,
                               name: string,
                               markAsUsed: boolean = false): Promise<string>
    {
        const preference = await this.getUserPreference(path, name, markAsUsed);
        return preference?.value;
    }

    public async getUserPreference(path: string,
                                   name: string,
                                   markAsUsed: boolean = false): Promise<Models.UserPreference>
    {
        if (markAsUsed) await this.markPreferenceAsUsed(path, name);
        return this.getUserPreferenceModel(path, name);
    }

    @ReportError
    public async markPreferenceAsUsed(path: string,
                                      name: string)
    {
        const request = Models.UserPreference.newInstance({
                                                              path: path,
                                                              name: name
                                                          });
        await this.m_api.userPreferenceApi.markAsUsed(this.m_users.userId, request);
    }

    @ReportError
    private async getUserPreferenceModel(path: string,
                                         name: string): Promise<Models.UserPreference>
    {
        const request = Models.UserPreferenceGetRequest.newInstance({
                                                                        path: path,
                                                                        name: name
                                                                    });
        return this.m_api.userPreferenceApi.get(this.m_users.userId, request);
    }

    @ReportError
    public deletePreference(path: string,
                            name: string): Promise<boolean>
    {
        return this.m_api.userPreferenceApi._delete(this.m_users.userId,
                                                    Models.UserPreferenceDeleteRequest.newInstance({
                                                                                                       path: path,
                                                                                                       name: name
                                                                                                   }));
    }
}
